import { FormEvent, useState } from "react";
import { Toaster } from "react-hot-toast";
import { ModalPopUp } from "../../../../components/ModalPopUp";
import { toastError, toastSuccess, toastWarn } from "../../../../components/Toast";
import useAuthData from "../../../../hook/useAppData";
import { currentDate } from "../../../../libs/dateUtils";
import { debitHours } from "../../service";
import { FormModalDebitHours } from "./components/Form";
import { IDebitHours, IListOption, IModalDebitHours, IModalProjectStatus, IModalStatus } from "./models";

const LIST_OPTION_DEBIT: IListOption[] = [
  { id: 1, name: "Pagamento", label: "PAID" },
  { id: 2, name: "Descanso", label: "REST" },
];

export function ModalDebitHours({ modalStatus, setModalStatus, doubleCard, setDoubleCard, reqHoursManagement }: IModalDebitHours): JSX.Element {
  const { token } = useAuthData();
  const [modalValue, setModalValue] = useState<IDebitHours>();
  const [optionSelect, setOptionSelect] = useState(0);
  const projectInfos = convertProjectInfo(modalStatus);
  const [hasNotifyOfValue, setHasNotifyOfValue] = useState<boolean>(false);

  function convertProjectInfo(modalStatus: IModalStatus): IModalProjectStatus {
    const project: IModalProjectStatus = {
      ...modalStatus?.project,
      balance: convertBalance(modalStatus?.project?.balance),
    };
    return project;
  }

  function convertBalance(balance): number {
    const newBalance = balance?.replace(":", ".");
    return +newBalance;
  }

  async function handleSubmitForm(event: FormEvent): Promise<string> {
    event.preventDefault();
    if (!optionSelect) return toastError("Formato do débito é obrigatório");
    const data = modalDebitHoursAdapter();
    const res = await debitHours(data, token);
    verefyRes(res);
  }

  function modalDebitHoursAdapter(): IDebitHours {
    return {
      ...modalValue,
      userId: modalStatus.user,
      projectId: projectInfos?.id,
      value: +modalValue?.value,
      status: getFormatSelected(),
      date: getMonthAndYear(),
      timeWorkClosedId: modalStatus.project.timeWorkClosedId,
    };
  }

  function getFormatSelected(): "PAID" | "REST" {
    const index = optionSelect - 1;
    return LIST_OPTION_DEBIT[index]?.label;
  }

  function getMonthAndYear(): string {
    const [currentYear, currentMonth] = currentDate().split("/");
    return `${currentYear}-${currentMonth}`;
  }

  function verefyRes(res: { ok: boolean }): string {
    if (!res?.ok) return toastError("Não foi possível fazer o débito");
    toastSuccess("Horas debitadas com sucesso");
    reqHoursManagement();
    setTimeout(() => {
      redirectView();
    }, 1000);
  }

  function redirectView(): void {
    if (doubleCard?.status) setDoubleCard({ userId: doubleCard?.userId, status: doubleCard?.status });
    return handleClickExitModal();
  }

  function handleClickExitModal(): void {
    setModalValue(undefined);
    setModalStatus(undefined);
    setOptionSelect(0);
  }

  function saveValueOfField(event: { name: string; value: string | number }): void {
    const { name, value } = event;
    setModalValue({ ...modalValue, [`${name}`]: value });
  }

  function verefyValueOfDebit(value: string): string {
    if (+value > projectInfos?.balance && !hasNotifyOfValue) {
      setHasNotifyOfValue(true);
      return toastWarn("Valor digitado maior que o Saldo em conta, verifique se está correto");
    } else if (+value < projectInfos?.balance) setHasNotifyOfValue(false);
  }

  return (
    <>
      <Toaster />
      <ModalPopUp title={`Saldo ${modalStatus?.project?.balance} horas`} status={!!modalStatus?.user} onClickCancel={handleClickExitModal}>
        <FormModalDebitHours
          handleSubmitForm={handleSubmitForm}
          modalValue={modalValue}
          saveValueOfField={saveValueOfField}
          LIST_OPTION_DEBIT={LIST_OPTION_DEBIT}
          optionSelect={optionSelect}
          setOptionSelect={setOptionSelect}
          handleClickExitModal={handleClickExitModal}
          verefyValueOfDebit={verefyValueOfDebit}
        />
      </ModalPopUp>
    </>
  );
}
